// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1zC3S","title":"BackImages_title__1D5hM","images":"BackImages_images__1iz0v"};